"use client";
import { Text as e } from "../Text/Text.mjs";
import { Check as t, ChevronRight as n } from "../Icon/icons.gen.mjs";
import { DEFAULT_ICON_CLASS_NAME as r } from "../../../utils/iconDefaults.mjs";
import { appendToChildren as i } from "../../../utils/appendToChildren.mjs";
import { forwardRef as a, isValidElement as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import * as c from "@radix-ui/react-context-menu";
//#region src/components/atoms/ContextMenu/ContextMenu.tsx
var l = (e) => /* @__PURE__ */ s(c.Root, {
	"data-slot": "context-menu",
	...e
}), u = a((e, t) => /* @__PURE__ */ s(c.Trigger, {
	"data-slot": "context-menu-trigger",
	...e,
	ref: t
}));
u.displayName = "ContextMenuTrigger";
var d = (e) => /* @__PURE__ */ s(c.Portal, {
	"data-slot": "context-menu-portal",
	...e
}), f = a((e, t) => /* @__PURE__ */ s(d, { children: /* @__PURE__ */ s(c.Content, {
	"data-slot": "context-menu-content",
	...e,
	ref: t
}) }));
f.displayName = "ContextMenuContent";
var p = a((e, t) => /* @__PURE__ */ s(c.Group, {
	"data-slot": "context-menu-group",
	...e,
	ref: t
}));
p.displayName = "ContextMenuGroup";
var m = a(({ children: t, fontSize: n = "sm", fontWeight: r = "semibold", fontFamily: i = "inter", ...a }, l) => /* @__PURE__ */ s(c.Label, {
	"data-slot": "context-menu-label",
	...a,
	ref: l,
	children: /* @__PURE__ */ s(e, {
		asChild: !0,
		fontSize: n,
		fontWeight: r,
		fontFamily: i,
		children: o(t) ? t : /* @__PURE__ */ s("span", { children: t })
	})
}));
m.displayName = "ContextMenuLabel";
var h = a((e, t) => /* @__PURE__ */ s(c.Item, {
	"data-slot": "context-menu-item",
	...e,
	ref: t
}));
h.displayName = "ContextMenuItem";
var g = a((e, t) => /* @__PURE__ */ s(c.CheckboxItem, {
	"data-slot": "context-menu-checkbox-item",
	...e,
	ref: t
}));
g.displayName = "ContextMenuCheckboxItem";
var _ = a((e, t) => /* @__PURE__ */ s(c.RadioGroup, {
	"data-slot": "context-menu-radio-group",
	...e,
	ref: t
}));
_.displayName = "ContextMenuRadioGroup";
var v = a((e, t) => /* @__PURE__ */ s(c.RadioItem, {
	"data-slot": "context-menu-radio-item",
	...e,
	ref: t
}));
v.displayName = "ContextMenuRadioItem";
var y = a(({ children: e, ...n }, r) => /* @__PURE__ */ s(c.ItemIndicator, {
	"data-slot": "context-menu-item-indicator",
	...n,
	ref: r,
	children: e ?? /* @__PURE__ */ s(t, {
		"data-slot": "context-menu-check-icon",
		"aria-hidden": "true",
		className: "size-4 shrink-0 [&_path]:fill-current"
	})
}));
y.displayName = "ContextMenuItemIndicator";
var b = a((e, t) => /* @__PURE__ */ s(c.Separator, {
	"data-slot": "context-menu-separator",
	...e,
	ref: t
}));
b.displayName = "ContextMenuSeparator";
var x = (e) => /* @__PURE__ */ s(c.Sub, {
	"data-slot": "context-menu-sub",
	...e
}), S = a(({ children: e, icon: t = /* @__PURE__ */ s(n, {
	"data-slot": "context-menu-sub-trigger-icon",
	"aria-hidden": "true",
	className: r
}), asChild: a, ...o }, l) => /* @__PURE__ */ s(c.SubTrigger, {
	"data-slot": "context-menu-sub-trigger",
	asChild: a,
	...o,
	ref: l,
	children: i(e, t, a)
}));
S.displayName = "ContextMenuSubTrigger";
var C = a((e, t) => /* @__PURE__ */ s(d, { children: /* @__PURE__ */ s(c.SubContent, {
	"data-slot": "context-menu-sub-content",
	...e,
	ref: t
}) }));
C.displayName = "ContextMenuSubContent";
var w = a((e, t) => /* @__PURE__ */ s(c.Arrow, {
	"data-slot": "context-menu-arrow",
	...e,
	ref: t
}));
w.displayName = "ContextMenuArrow";
//#endregion
export { w as ContextMenuArrow, g as ContextMenuCheckboxItem, f as ContextMenuContent, p as ContextMenuGroup, h as ContextMenuItem, y as ContextMenuItemIndicator, m as ContextMenuLabel, d as ContextMenuPortal, _ as ContextMenuRadioGroup, v as ContextMenuRadioItem, l as ContextMenuRoot, b as ContextMenuSeparator, x as ContextMenuSub, C as ContextMenuSubContent, S as ContextMenuSubTrigger, u as ContextMenuTrigger };
